<template>
  <modal titulo="Anexar Documentos">
    <anexos-wrapper-ato-registrado nome="Anexos do Ato" :entidade="entidade" :id="id" :permitir-edicao="permitirEdicao" :permite-excluir-anexo="permiteExcluirAnexo" :permite-ia="permiteIa" :permite-tags="permiteTags"/>
    <anexos-wrapper-ato-registrado v-if="atoId" nome="Anexo do Livro" entidade="ATO_LIVRO" :id="atoId" :permitir-edicao="permitirEdicao" :insert="false" :permite-excluir-anexo="false" :permite-ia="false" :permite-tags="false"/>
  </modal>
</template>

<script>

import {defineComponent} from "vue";
import Modal from "@/components/Modal.vue";
import EventBus from "@/commons/EventBus";
import AnexosWrapperAtoRegistrado from "@/components/Anexos/AnexosWrapperAtoRegistrado.vue";

export default defineComponent({
  components: {AnexosWrapperAtoRegistrado, Modal},
  props: {
    id: Array,
    entidade: String,
    permitirEdicao: Boolean,
    permiteExcluirAnexo: {type: Boolean, default: true},
    permiteIa: {type: Boolean, default: true},
    permiteTags: {type: Boolean, default: true},
    atoId: {type: String, default: null},
  },

  beforeDestroy() {
    EventBus.$emit('anexos-modal-closed');
  }
})
</script>

<style>

</style>
